import {
    AVATARS,
    AVATAR_GROUP_QUOTE_TYPE,
    DISORDER_METADATA_AVATAR_TYPE_NAME,
    GROUP_AVATARS,
    METADATA_AVATAR_TYPES,
    TREATMENT_METADATA_AVATAR_TYPE_NAME,
} from '@/utils/CONST';
import {
    ChipField,
    Datagrid,
    DateField,
    FunctionField,
    Identifier,
    List,
    ReferenceArrayField,
    ReferenceField,
    SingleFieldList,
    TextField,
    useTranslate,
} from 'react-admin';
import { last, split } from 'lodash';

interface Props {
    selectedId: Identifier;
}

const DisorderTreatmentCompactList = ({ selectedId }: Props) => {
    const translate = useTranslate();

    return (
        <List
            actions={false}
            component='div'
            resource={AVATARS}
            filter={{
                metadataAvatarTypeEName: [TREATMENT_METADATA_AVATAR_TYPE_NAME, DISORDER_METADATA_AVATAR_TYPE_NAME],
                'groupAvatars.id': selectedId,
            }}
            empty={false}
            storeKey='disordersTreatmentList'
            // filters={filters(translate)}
            sort={{
                field: 'creationDate',
                order: 'DESC',
            }}
            queryOptions={{
                enabled: !!selectedId,
            }}
        >
            <Datagrid bulkActionButtons={false}>
                <FunctionField
                    render={({ alphaId }: { alphaId: string }) => split(alphaId, ':')[1]}
                    label={'disorder.list.number'}
                />

                <ReferenceField
                    source='metadataAvatarType'
                    reference={METADATA_AVATAR_TYPES}
                    label={'disorder.list.type'}
                >
                    {/*<TextField source={'name'} />*/}
                    <FunctionField
                        render={({ name }: { name: string }) => translate(`disorder.list.${last(split(name, ':'))}`)}
                    />
                </ReferenceField>

                <TextField source='name' label='disorder.list.subtype' />

                <DateField
                    options={{ year: 'numeric', month: '2-digit', day: '2-digit' }}
                    source={'creationDate'}
                    label={'disorder.list.creation_date'}
                />

                {/*{permissions?.includes(ROLE_BIG_UPDATE_DEMAND_STATUS) ? (*/}
                {/*    <FunctionField*/}
                {/*        render={({ currentNode, id }: any) => (*/}
                {/*            <ChangeStatusField*/}
                {/*                avatarUriId={id}*/}
                {/*                currentNode={currentNode}*/}
                {/*                choices={DISORDER_CHANGE_STATUS_NODE_LIST}*/}
                {/*            />*/}
                {/*        )}*/}
                {/*        label='intervention.list.status'*/}
                {/*    />*/}
                {/*) : (*/}
                {/*    <TextField source='currentNode.name' label='intervention.list.status' />*/}
                {/*)}*/}

                <DateField
                    sortable={false}
                    options={{ year: 'numeric', month: '2-digit', day: '2-digit' }}
                    source={'currentNode.dateOfTakesPlace'}
                    label='intervention.list.status_date'
                />

                <ReferenceArrayField
                    reference={GROUP_AVATARS}
                    source='groupAvatars'
                    label='disorder.list.present_devis'
                    sx={{
                        '& > span > div': {
                            display: 'flex',
                            gap: 0.2,
                        },
                    }}
                    filter={{ type: AVATAR_GROUP_QUOTE_TYPE }}
                >
                    <SingleFieldList linkType={false}>
                        <ChipField source='name' />
                    </SingleFieldList>
                </ReferenceArrayField>

                {/*<FunctionField*/}
                {/*    render={(avatar: any) => (*/}
                {/*        <AvatarActionField avatar={avatar} withDelete={permissions?.includes(ROLE_BIG_DELETE_DEMAND)} />*/}
                {/*    )}*/}
                {/*/>*/}
            </Datagrid>
        </List>
    );
};

export default DisorderTreatmentCompactList;
